import React from 'react';
import { Box } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import ServicesSection from '../components/ServicesSection.jsx';
import Footer from '../components/Footer.jsx';

const ServicesPage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header />
      <Box as="main" flex="1">
        <ServicesSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default ServicesPage;
